module.exports = __webpack_public_path__ + "static/media/therapy_coaching.a7bfb203.png";